import ClientTransactions from './ClientTransactions';

export default ClientTransactions;